import { useCallback, useMemo, useState } from "react";
import type { IUseListFilterParams } from "../types/api/common";

export const useListFilter = <T>({
  items,
  getSearchValue,
}: IUseListFilterParams<T>) => {
  const [search, setSearch] = useState("");

  const normalizedSearch = search.trim().toLowerCase();

  const filteredItems = useMemo(() => {
    const list = items ?? [];

    if (!normalizedSearch) {
      return list;
    }

    return list.filter((item) => {
      const searchValue = getSearchValue(item) ?? "";

      return searchValue.toLowerCase().includes(normalizedSearch);
    });
  }, [items, normalizedSearch, getSearchValue]);

  const clearSearch = useCallback(() => {
    setSearch("");
  }, []);

  return {
    search,
    setSearch,
    clearSearch,
    filteredItems,
    isFilteredEmpty: filteredItems.length === 0,
  };
};
